// skipcq: JS-W1028
import { useEffect, useState } from 'react';
import { Alert, Box, CircularProgress, Paper, Typography } from '@mui/material';
import { useSearchParams } from 'react-router-dom';

export function resolveFunctionsBaseUrl() {
  const projectId = import.meta.env.VITE_PROJECT_ID;
  if (typeof projectId !== 'string' || projectId.length === 0) {
    return null;
  }
  return `https://us-central1-${projectId}.cloudfunctions.net`;
}

export function resolveUnsubscribeEndpoint(functionsBaseUrl, scope) {
  if (scope === 'newsletter') {
    return `${functionsBaseUrl}/dbEmailMailgunEvents-unsubscribeNewsletter`;
  }
  return `${functionsBaseUrl}/dbEmailMailgunEvents-unsubscribeBreweryActivityEmail`;
}

function EmailUnsubscribePage() {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('loading');
  const [message, setMessage] = useState('Processing your unsubscribe request...');

  useEffect(() => {
    const token = searchParams.get('token');
    const scope = searchParams.get('scope');
    if (typeof token !== 'string' || token.length === 0) {
      setStatus('error');
      setMessage('Missing unsubscribe token.');
      return undefined;
    }

    const functionsBaseUrl = resolveFunctionsBaseUrl();
    if (!functionsBaseUrl) {
      setStatus('error');
      setMessage('Unable to resolve unsubscribe endpoint.');
      return undefined;
    }

    let cancelled = false;
    (async () => {
      try {
        const endpoint = resolveUnsubscribeEndpoint(functionsBaseUrl, scope);
        const response = await fetch(
          `${endpoint}?token=${encodeURIComponent(token)}`,
        );
        const responseText = await response.text();
        if (cancelled) {
          return;
        }
        if (!response.ok) {
          setStatus('error');
          setMessage(responseText || 'Unable to unsubscribe.');
          return;
        }
        setStatus('success');
        setMessage(responseText);
      } catch {
        if (!cancelled) {
          setStatus('error');
          setMessage('Unable to process unsubscribe request.');
        }
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [searchParams]);

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        p: 3,
      }}
    >
      <Paper sx={{ p: 4, maxWidth: 560, width: '100%' }}>
        {status === 'loading' ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', py: 2 }}>
            <CircularProgress />
          </Box>
        ) : null}
        <Typography variant="h5" gutterBottom>
          Email preferences
        </Typography>
        {status === 'success' ? <Alert severity="success">{message}</Alert> : null}
        {status === 'error' ? <Alert severity="error">{message}</Alert> : null}
      </Paper>
    </Box>
  );
}

export default EmailUnsubscribePage;
